import { Button, Center, Stack, Title, Group } from '@mantine/core';
import { FcGoogle } from 'react-icons/fc';
import { button } from './component.css';
import Huuva from './huuva.svg?react';

export default function Login() {
  return (
    <Center h="75vh">
      <Stack w="260px" gap="0">
        <Group gap="sm" justify="center">
          <Huuva color="#ff6b47" />
        </Group>
        <Group justify="center" align="center" mt="30" mb="48">
          <Title order={2}>Log in</Title>
        </Group>
        <Button
          className={button}
          component="a"
          href="/auth/discovery/google"
          leftSection={<FcGoogle size={24} />}
        >
          Continue with Google
        </Button>
      </Stack>
    </Center>
  );
}
